import { createI18n } from 'vue-i18n'
import { useLocalStorage } from '@vueuse/core'
import en from './language/en'
import zhCH from './language/zh-ch'

/**
 * Amount formatting
 */
export function formatAmountFunc(num) {
  return new Intl.NumberFormat("en-US", {
		style: "decimal", // 让数字以普通数字的方式显示，不会加货币符号或百分号
		minimumFractionDigits: 2, // 小数点后数字最小限制
		maximumFractionDigits: 2, // 小数点后数字最大限制
		useGrouping: true, // 是否显示千位分隔符
	}).format(num)
}


const langRef = useLocalStorage('language', 'en')

const messages = { en, zhCH }

const i18n = createI18n({ locale: langRef.value, messages })

const languageList = Object.keys(messages).map(k =>
  ({ label: messages[k].title, value: k })
)

const setLanguage = (item = { label: '', value: '' }) => {
  i18n.locale = item.value
  langRef.value = item.value
  setTimeout(() => {
    window.location.replace(document.referrer)
  }, 200);
}

const t = i18n.global.t

const moneyFlag = process.env.VUE_APP_MONEY_FLAG

const fm = (money) => {
  let _val = formatAmountFunc(Number(money)||0)
  return `${moneyFlag} ${_val}`
}

const fn = (money) => {
  let _val = formatAmountFunc(Number(money)||0)
  return _val
}

export default i18n
export { t, langRef, languageList, setLanguage, fm, fn }
